import { en, type Copy } from './en';
import { zhTW } from './zh-TW';
import { ja } from './ja';
import { ko } from './ko';
import { th } from './th';
import { useLocale, type Locale } from './locale';

const COPY: Record<Locale, Copy> = { en, 'zh-TW': zhTW, ja, ko, th };

export const copyFor = (locale: Locale): Copy => COPY[locale];

export const useCopy = (): Copy => copyFor(useLocale());

export type { Copy } from './en';
export * from './locale';
export { stripWordJoiners } from './wordJoiner';
